export function createZoneSupplyReadModelClient(transport) {
    return {
        /**
         * Demand and supply per zone, with how each zone stands
         *
         * Requires scope: dispatch-operations:read
         */
        readZoneSupply(options) {
            return transport.request({
                method: "GET",
                path: "/v1/zone-supply",
                options,
            });
        },
        /**
         * Discard the projection and let it rebuild
         *
         * Requires scope: dispatch-operations:reset
         */
        resetZoneSupply(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/zone-supply/resets",
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=zone-supply-read-model.js.map